import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsHoloX.js";

const resultsArr = videoList.Chloe;

class Chloe extends React.Component{
    render(){
    
      return(
            <div id="wrapper">

				{/* Header */}
				<Header />

				{/* Menu */}

				{/* Main */}
                <StreamDisplay talentName="Sakamata Chloe" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Chloe